import { apiClient } from '../../config/axios.config';
import { BASE_URL, BASE_CALIBRATION_URL } from '../apiConfig';

const addCalibrationSession = async payload => {
  const response = await apiClient.create(
    `${BASE_URL}${BASE_CALIBRATION_URL}/create-calibration-header`,
    payload,
  );
  return response;
};

const fetchCalibrationHeader = async payload => {
  const response = await apiClient.create(
    `${BASE_URL}${BASE_CALIBRATION_URL}/get-calibration`,
    payload,
  );
  return response;
};

const fetchCalibrationDetail = async payload => {
  const response = await apiClient.create(
    `${BASE_URL}${BASE_CALIBRATION_URL}/get-calibration`,
    payload,
  );
  return response;
};

const validatealiateEmployeeCodes = async payload => {
  const response = await apiClient.create(
    `${BASE_URL}${BASE_CALIBRATION_URL}/validate-employee-codes`,
    payload,
  );
  return response;
};

const deleteCalibration = async payload => {
  const response = await apiClient.create(
    `${BASE_URL}${BASE_CALIBRATION_URL}/delete-calibration`,
    payload,
  );
  return response;
};

const calibrationBySessionId = async payload => {
  const response = await apiClient.create(
    `${BASE_URL}${BASE_CALIBRATION_URL}/calibration-by-sessionid`,
    payload,
  );
  return response;
};

const updateOverAllRating = async payload => {
  const response = await apiClient.create(
    `${BASE_URL}${BASE_CALIBRATION_URL}/update-overall-rating`,
    payload,
  );
  return response;
};

const saveCalibrationSubject = async payload => {
  const response = await apiClient.create(
    `${BASE_URL}${BASE_CALIBRATION_URL}/save-calibration-subject`,
    payload,
  );
  return response;
};

const calibrationMatrix = async payload => {
  const response = await apiClient.create(
    `${BASE_URL}${BASE_CALIBRATION_URL}/calibration-matrix`,
    payload,
  );
  return response;
};

const calibrationEmployeeList = async payload => {
  const response = await apiClient.create(
    `${BASE_URL}${BASE_CALIBRATION_URL}/calibration-employee-list`,
    payload,
  );
  return response;
};

const calibrationList = async payload => {
  const response = await apiClient.create(
    `${BASE_URL}${BASE_CALIBRATION_URL}/calibration-list`,
    payload,
  );
  return response;
};

const updateCalibrationSubject = async payload => {
  const response = await apiClient.create(
    `${BASE_URL}${BASE_CALIBRATION_URL}/update-calibration-subject`,
    payload,
  );
  return response;
};

export {
  fetchCalibrationHeader,
  fetchCalibrationDetail,
  addCalibrationSession,
  validatealiateEmployeeCodes,
  deleteCalibration,
  calibrationBySessionId,
  updateOverAllRating,
  calibrationMatrix,
  calibrationEmployeeList,
  calibrationList,
  saveCalibrationSubject,
  updateCalibrationSubject,
};
